





















import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { SdsLink } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    ref,
} from '@vue/composition-api';
import Vue from 'vue';

import { AboutSuperbetLink } from '@modules/layout/footer/types';
import ExternalLink from '@shared/components/ExternalLink.vue';
import StaticLink from '@shared/components/StaticLink.vue';
import CustomRouterLink from '@shared/components/router/CustomRouterLink.vue';

import { aboutSuperbetLinks } from '../aboutSuperbetLinks';
import { NavigationKind } from '@app/router/types';

import FooterColumnsTitle from './FooterColumnsTitle.vue';
import { getWikiPath } from '@modules/wiki/navigateToWiki';

export default defineComponent({
    name: 'AboutSuperbet',
    // eslint-disable-next-line sonarjs/cognitive-complexity
    setup() {
        const links = ref<AboutSuperbetLink[]>([]);

        // TODO MGA_LICENCE: this code is going down as soon as we finish MGA audit
        // MGA audit is conducted only on stage.com env.
        // Tomica: Boris can we remove this?
        if (getConfig().countrySpecific.country === Country.Com
            && window.location.href.includes('stage')) {
            links.value = aboutSuperbetLinks.map((link) => {
                if (link.label === 'privacy policy') {
                    // eslint-disable-next-line no-param-reassign
                    link.label = 'privacy notice';
                }
                return link;
            });
            featureFlagService.getFeatureValue(
                'web.is-mga-audit',
                true,
            ).then((flag) => {
                if (!flag) {
                    links.value = aboutSuperbetLinks.map((link) => {
                        if (link.label === 'privacy notice') {
                            // eslint-disable-next-line no-param-reassign
                            link.label = 'privacy policy';
                        }
                        return link;
                    });
                }
                return flag;
            }).catch(() => {
                // ignore, not important
            });
        } else {
            links.value = aboutSuperbetLinks;
        }

        function component(link: AboutSuperbetLink): string | Vue.Component {
            const components = {
                external: ExternalLink,
                static: StaticLink,
                route: CustomRouterLink,
            };
            return components[link.type];
        }

        function prepareProps(link: AboutSuperbetLink) {
            const {
                e2e: _e2e,
                type: _type,
                ...props
            } = link;
            return props;
        }

        function getTo(link: AboutSuperbetLink) {
            switch (link.type) {
                case 'route':
                    return {
                        name: link.routeName,
                    };
                case 'external':
                    if (!link.path!.startsWith('http')) {
                        return `${window.location.protocol}//${window.location.host}${link.path}`;
                    } else {
                        return link.path;
                    }
                case 'static':
                    return getWikiPath(link.path!);
            }
        }

        return {
            NavigationKind,
            links,
            component,
            prepareProps,
            getTo,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsLink,
    },
});
